module.exports = __webpack_public_path__ + "img/n-excretion.2de7ce3f.png";